import React, { Component } from 'react';

/**
 * Placeholder for a content element that is being loaded.
 * Shows an element with a title and, below it, a form with a single column where each cell contains a loading bar element.
 */
class NoColContentLoadPlaceholder extends Component {
    render() {
        return (
            <div className="ph-item">
                <div className="ph-col-12">
                    <div className="ph-row">
                        <div className="ph-col-2 ph-col-sm-6 bigger"></div>
                        <div className="ph-col-10 ph-col-sm-6 empty"></div>
                    </div>
                    <div className="ph-row">
                        <div className="ph-col-12 extra-big margin-top-small"></div>
                    </div>
                    <div className="ph-row">
                        <div className="ph-col-12 extra-big margin-top-medium"></div>
                    </div>
                    <div className="ph-row">
                        <div className="ph-col-12 extra-big margin-top-medium"></div>
                    </div>
                    <div className="ph-row ph-row-sm-hide">
                        <div className="ph-col-12 extra-big margin-top-medium"></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NoColContentLoadPlaceholder;